import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Dropdown from '../../Dropdown';
import styles from '../Navigation.css';
import { trackPUAnalytics } from '../../../services/Mixpanel';

const NavigationBarRightContainer = ({
  me,
  isMobile,
  isTablet,
  links,
}) => {
  if (!me || links.length === 0) return null;

  if (isMobile || isTablet) {
    return (
      <span>{me.firstName}</span>
    );
  }

  const handleClick = (id) => {
    if (id === 'logout') {
      trackPUAnalytics('PathwayU:LogOut', { pageLocation: window.location.href });
    }
  };

  return (
    <Dropdown
      label={`My Account: ${me.firstName}`}
      button={
        <button className={styles.navbarMenu}>
          {me.firstName}
        </button>
      }
      dropdownClassName={styles.navbarMenuDropdown}
    >
      {links.map(({ id, path, name, isExact }) => (
        <Link
          key={id}
          to={path}
          onClick={() => handleClick(id)}
          exact={isExact.toString()}
          className={styles.navbarMenuItem}
        >
          {name}
        </Link>
      ))}
    </Dropdown>
  );
};

NavigationBarRightContainer.propTypes = {
  me: PropTypes.object,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      path: PropTypes.string,
      isExact: PropTypes.bool,
    }),
  ),
};

export default NavigationBarRightContainer;



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/components/NavigationBarRightContainer.js